import {ChangeDetectionStrategy, Component, signal} from "@angular/core"
import {MathOperator} from "@cm/template-nodes"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"

@Component({
    selector: "cm-math-operator-inspector",
    templateUrl: "./math-operator-inspector.component.html",
    styleUrl: "./math-operator-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MathOperatorInspectorComponent extends BaseInspectorComponent<MathOperator> {
    readonly $typePossibilities = signal<SelectionPossibilities<MathOperator["parameters"]["type"]>>([
        {value: "add", name: "Add"},
        {value: "sub", name: "Subtract"},
        {value: "mul", name: "Multiply"},
        {value: "div", name: "Divide"},
        {value: "mod", name: "Modulo"},
        {value: "max", name: "Maximum"},
        {value: "min", name: "Minimum"},
        {value: "gt", name: "Greater Than"},
        {value: "lt", name: "Less Than"},
        {value: "gte", name: "Greater Than or Equal"},
        {value: "lte", name: "Less Than or Equal"},
        {value: "eq", name: "Equal"},
        {value: "ne", name: "Not Equal"},
        {value: "and", name: "And"},
        {value: "or", name: "Or"},
        {value: "not", name: "Not"},
        {value: "sin", name: "Sine"},
        {value: "cos", name: "Cosine"},
        {value: "sqrt", name: "Square Root"},
        {value: "exp", name: "Exponent"},
        {value: "log", name: "Logarithm"},
        {value: "neg", name: "Negate"},
        {value: "abs", name: "Absolute"},
        {value: "floor", name: "Floor"},
        {value: "ceil", name: "Ceil"},
        {value: "round", name: "Round"},
    ])
}
